const DESKTOP_BREAKPOINT = 1024;

const PRIMARY_NAV = [
  { name: 'index', text: '商城', names: ['order', 'index'], icon: 'HomeIcon' },
  { name: 'takings', text: '訂單', names: ['takings'], icon: 'ClipboardIcon' },
  { name: 'me', text: '我的', names: ['me'], icon: 'UserIcon' },
];

function destinationLabels() {
  return PRIMARY_NAV.map((item) => item.text);
}

function isDesktopWidth(width) {
  return Number(width) >= DESKTOP_BREAKPOINT;
}

function chromeForWidth(width) {
  const destinations = destinationLabels();

  if (isDesktopWidth(width)) {
    return {
      mode: 'desktop',
      shellMaxClass: 'max-w-[1200px]',
      showBottomNav: false,
      showTopNav: true,
      showAppBar: false,
      cartInsetClass: '',
      productOverlay: 'page',
      destinations,
    };
  }

  return {
    mode: 'mobile',
    shellMaxClass: 'max-w-screen-sm',
    showBottomNav: true,
    showTopNav: false,
    showAppBar: true,
    cartInsetClass: 'pl-[112px]',
    productOverlay: 'sheet',
    destinations,
  };
}

module.exports = {
  DESKTOP_BREAKPOINT,
  PRIMARY_NAV,
  destinationLabels,
  isDesktopWidth,
  chromeForWidth,
};
